export default "__VITE_ASSET__y$UVAbHk__"